module.exports = __webpack_public_path__ + "img/ic_in-question-list.e768b7a5.svg";